<div class="m-step-indicator" [class.-small]="small">
  <ul *ngIf="steps" class="m-step-indicator__steps">
    <ng-container *ngFor="let step of steps; trackBy: trackByFn">
      <ng-container *ngTemplateOutlet="step.template"></ng-container>
    </ng-container>
  </ul>
</div>
